import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { selectSiteUrl, selectStoreCount } from 'core/selectors/app';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

import replaceTemplateValueInString from 'core/utils/helpers/replaceTemplateValueInString';
import SearchProductsLink from '../SearchProductsLink/SearchProductsLink';

import './MerchantSuspendedActionMessages.scss';

function MerchantSuspendedActionMessages({
  config, keywords, siteUrl, storeCount,
}) {
  const {
    moreStoresSuspendedHeader, moreStoresSuspendedMessage, moreProductSuspendedHeader, sid,
  } = config;

  if (!moreStoresSuspendedHeader || !moreStoresSuspendedMessage) {
    return null;
  }

  return (
    <div className="mn_suspendedActionMessages" data-test="suspended-action-message">
      <div className="mn_productContainer">
        <h3 data-test="suspended-action-title">{moreStoresSuspendedHeader}</h3>
        <p data-test="suspended-action-message-text">
          {
          storeCount
            ? replaceTemplateValueInString(moreStoresSuspendedMessage.withStoreCount, { storeCount })
            : moreStoresSuspendedMessage.withoutStoreCount
          }
        </p>
        <a
          href={`${siteUrl}/b____.htm`}
          className="mn_suspendedActionLink"
          data-test="suspended-action-link"
        >
          View all stores
        </a>
      </div>
      {keywords && (
        <div className="mn_productContainer" data-test="suspended-action-more-products">
          <h3>{moreProductSuspendedHeader}</h3>
          <p>Search products for "{keywords}"</p>
          <SearchProductsLink sid={sid} className="mn_suspendedActionLink" text="Search products" />
        </div>
      )}
    </div>
  );
}

MerchantSuspendedActionMessages.propTypes = {
  merchant: PropTypes.shape({}),
  config: PropTypes.shape({}),
  keywords: PropTypes.string,
  siteUrl: PropTypes.string,
  storeCount: PropTypes.string,
};

MerchantSuspendedActionMessages.defaultProps = {
  merchant: {},
  config: {},
  keywords: '',
  siteUrl: '',
  storeCount: '',
};

const mapStateToProps = state => ({
  siteUrl: selectSiteUrl(state),
  storeCount: selectStoreCount(state),
});

export default connect(mapStateToProps)((props) =>
  <ComponentErrorBoundary><MerchantSuspendedActionMessages {...props} /></ComponentErrorBoundary>);
